/**
 * W4 (BUGHUNT-2026-08-15): Live-Vorschau des Preis-Reglers im Angebots-Builder (8d).
 *
 * Die Vorschau parste bisher mit `Number(raw.replace(",", "."))` — ein anderer Parser als der
 * Blur-Pfad (`parseGermanDecimal`). Ergebnis: die Eingabe „1.500" zeigte als Vorschau
 * „Neu: 1,50 €", waehrend der Blur korrekt 1.500,00 € setzte. Jetzt nutzen beide Pfade
 * denselben Parser; eine Eingabe, die der Blur ablehnen wuerde, bekommt auch keine Vorschauzeile.
 *
 * Rein clientseitige Anzeige — autoritativ bleibt der Server-Response nach Blur/Submit
 * (setDiscount/setTargetPrice unveraendert, Summen rechnet packages/pricing).
 */
import { money, parseGermanDecimal } from "../ui/format";

export type RabattModus = "percent" | "amount" | "target";

/** Vorschauzeile fuer den Preis-Regler — `null` bei leerer oder ungueltiger Eingabe. */
export function rabattVorschauZeile(raw: string, modus: RabattModus, subtotalCents: number): string | null {
  const trimmed = raw.trim();
  if (!trimmed) return null;
  const num = parseGermanDecimal(trimmed);
  if (num == null) return null;
  const finalCents =
    modus === "percent"
      ? Math.round(subtotalCents * (1 - Math.max(0, num) / 100))
      : modus === "amount"
        ? subtotalCents - Math.round(num * 100)
        : Math.round(num * 100);
  return `Neu: ${money(finalCents)} (statt ${money(subtotalCents)})`;
}
